<template>
    <a
        href="#"
        class="event-compact-link"
        @click.prevent="$emit('open', {id: event.id})">
        <span v-if="eventTime">
            {{ eventTime }} Uhr -
        </span>
        <span class="font-weight-bolder">
            {{ event.name }}
        </span>
    </a>
</template>

<script>
export default {
    name: "EventEntryLink",
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    computed: {
        eventTime() {
            if (!this.event?.startDate) return null
            const eventMoment = this.$moment(this.event.startDate)
            if (eventMoment.isSame(eventMoment.clone().startOf('day'), 'minute')) return null
            return eventMoment.format('HH:mm')
        }
    }
}
</script>

<style scoped>

</style>
